import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#0f0a1f] text-gray-300 pt-16 pb-8 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="md:col-span-2 max-w-sm">
          <h3 className="text-2xl font-extrabold mb-3 text-white">Waveo</h3>
          <p className="text-sm text-gray-400 leading-relaxed mb-5">{t('footer.tagline')}</p>
          <div className="flex gap-3">
            <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M22 12a10 10 0 10-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.2c-1.2 0-1.6.8-1.6 1.6V12h2.7l-.4 2.9h-2.3v7A10 10 0 0022 12z" /></svg>
            </a>
            <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.8.3 2.2.4.6.2 1 .5 1.4.9.4.4.7.8.9 1.4.1.4.3 1 .4 2.2.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.3 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.8.7-1.4.9-.4.1-1 .3-2.2.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.8-.3-2.2-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.8-.9-1.4-.1-.4-.3-1-.4-2.2C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.3-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.8-.7 1.4-.9.4-.1 1-.3 2.2-.4C8.4 2.2 8.8 2.2 12 2.2zm0 3.2A6.6 6.6 0 1018.6 12 6.6 6.6 0 0012 5.4zm0 10.9A4.3 4.3 0 1116.3 12 4.3 4.3 0 0112 16.3zm6.8-11.1a1.5 1.5 0 11-1.5-1.5 1.5 1.5 0 011.5 1.5z" /></svg>
            </a>
          </div>
        </div>

        {/* Product */}
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">{t('footer.productTitle')}</h4>
          <ul className="space-y-3 text-sm">
            <li><a href="/#features" className="hover:text-white transition">{t('footer.product.features')}</a></li>
            <li><a href="/#pricing" className="hover:text-white transition">{t('footer.product.pricing')}</a></li>
            <li><Link to="/radios" className="hover:text-white transition">{t('footer.product.explore')}</Link></li>
            <li><a href="#" className="hover:text-white transition">{t('footer.product.mobile')}</a></li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">{t('footer.companyTitle')}</h4>
          <ul className="space-y-3 text-sm">
            <li><a href="#" className="hover:text-white transition">{t('footer.company.about')}</a></li>
            <li><a href="mailto:contact@waveo.net" className="hover:text-white transition">{t('footer.company.contact')}</a></li>
            <li><a href="#" className="hover:text-white transition">{t('footer.company.terms')}</a></li>
            <li><a href="#" className="hover:text-white transition">{t('footer.company.privacy')}</a></li>
          </ul>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-gray-500">
          © {new Date().getFullYear()} Waveo — {t('footer.rights')}
        </p>
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-500">{t('footer.langLabel')}</span>
          <LanguageSwitcher variant="dark" />
        </div>
      </div>
    </footer>
  );
}
